import { render, staticRenderFns } from "./gc-status-chip-yes-no.vue?vue&type=template&id=08eddd74&scoped=true"
import script from "./gc-status-chip-yes-no.vue?vue&type=script&lang=js"
export * from "./gc-status-chip-yes-no.vue?vue&type=script&lang=js"
import style0 from "./gc-status-chip-yes-no.vue?vue&type=style&index=0&id=08eddd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eddd74",
  null
  
)

export default component.exports